// 🌍 Upload direto para o servidor Trekkin.pt (CPANEL)
// Compatível com eventos, trilhos e fotos de perfil futuramente

export async function uploadImageToServer(file) {
  const form = new FormData();
  form.append("file", file);

  const res = await fetch("https://www.trekkin.pt/app/app-upload/upload-image.php", {
    method: "POST",
    body: form,
  });

  const raw = await res.text();
  let data;
  try {
    data = JSON.parse(raw);
  } catch {
    throw new Error(res.ok ? "O servidor devolveu uma resposta inválida." : `Falha no upload (${res.status}).`);
  }
  if (!res.ok) throw new Error(data?.error || `Falha no upload (${res.status}).`);
  if (!data.success) throw new Error(data.error || "Erro ao enviar imagem");

  return data.url;
}

export async function uploadGPXToServer(file) {
  const form = new FormData();
  form.append("file", file);

  const res = await fetch("https://www.trekkin.pt/app/app-upload/upload-gpx.php", {
    method: "POST",
    body: form,
  });

  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Erro ao enviar GPX");

  return data.url;
}
